import React from "react";
import { auth } from "../services/firebase";
import {
  GoogleAuthProvider,
  AuthProvider,
  signInWithPopup, // Add this import
} from "firebase/auth";
import { JoinButton } from "./header/style";

import { createUserProfileDocument } from "../services/authService";
import Box from "@mui/material/Box";

const Signup: React.FC = () => {
  const handleSignup = async (provider: AuthProvider) => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      await createUserProfileDocument(user);
      console.log("User signed up:", user);
    } catch (error) {
      console.error("Error during signup:", error);
    }
  };

  return (
    <JoinButton onClick={() => handleSignup(new GoogleAuthProvider())}>
      Start your journey
    </JoinButton>
  );
};

export default Signup;
